// extracted by mini-css-extract-plugin
export default {"leftStart":"_pw7NRY_sdF9lJhVSa93","leftEnd":"d_QPnu1zMe6fAoiA2ACA","bottomEnd":"pne0qyHBHHUO2vHxkih9","bottomStart":"zR85CPouS_VxCWKmp28q"};